import React, { Component } from 'react'

import { ReactComponent as IconArrowBack } from 'Assets/icon/arrow-back.svg'

export default class Navigation extends Component {
	render() {
		return (
			<div className='navigation'>
				<IconArrowBack onClick={() => window.history.back()} />
				<span>Offer details</span>
			</div>
		)
	}
}
